import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {AccountTabsLayout} from "../../../common/account-tabs-layout/account-tabs-layout";

export const ApmPrefsLayout = ({activeTab, next}) => cs(

    consumeContext("accountMenu"),
    ({accountMenu}, next) => AccountTabsLayout({
        activeMenu: "programDefaults",
        activeTab,
        config: accountMenu?.["programDefaultsMenu"]?.dropdownItems ?? getItems({}),
        next,
    }),
    () => next(),
);

const getItems = ({}) => [
    {
        linkLabel: "Postcards",
        name : "postcards",
        link: "/account/program-defaults/apm-prefs/postcards",
    },
    {
        linkLabel: "Flyers",
        name : "flyers",
        link: "/account/program-defaults/apm-prefs/flyers",
    },
    {
        linkLabel: "Brochures",
        name : "brochures",
        link: "/account/program-defaults/apm-prefs/brochures",
    },
    {
        linkLabel: "Social Media",
        name : "social-media",
        link: "/account/program-defaults/apm-prefs/social-media",
    },
];
